import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c372ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desc cm-ui-mt5" }
const _hoisted_2 = { class: "cm-ui-mb5 cm-ui-mt20" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    title: _ctx.$t('groupClient.terminalActionMessagePush'),
    "model-value": _ctx.props.modelValue,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleEvent('close'))),
    width: 550
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleEvent('confirm'))),
        disabled: (_ctx.state.info.length === 0) || (_ctx.state.info.length > 100)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('groupClient.messagePushButton')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        size: "small",
        modelValue: _ctx.state.info,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.info) = $event)),
        type: "textarea",
        placeholder: _ctx.$t('groupClient.messagePushContentPlaceholder'),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEvent('input'))),
        class: "push-msg",
        rows: 5
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('groupClient.messagePushHintAfterSend')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('groupClient.registerInfoModalPreviewTitle')), 1),
      _createElementVNode("img", {
        src: _ctx.registeInfoPic,
        width: "300",
        alt: _ctx.$t('groupClient.registerInfoModalPreviewAlt')
      }, null, 8, _hoisted_3)
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}